import {Row, Col , Card, Button, Tabs, Table} from 'antd';

import '../style/style.css';

import { cardmargin, grayheader } from '../../CSSReferences';
import { Component } from 'react';
import { mandantendetails, userdetails } from '../typing/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from '../../../intl-compat';


export interface LocalProps{
  //defince local porperies (maybe as tag parameter)
  // ONLY TYPES; NO VALUES
    
    userdetails:userdetails;
    usermandanten:mandantendetails[];
    listmandanten:mandantendetails[];
    loadeduuid:string;
    loaded:boolean;
    key:string;
  // FUNCTIONS ALSO INCLUDE
  onSubmit: (data:any, uuid:any) => void;
  deactivateUser:(uuid:string)=> void;
  deleteUser:(uuid:string)=> void;
  onLoadRequested:(uuid:string)=>void;
  requestUserCLientListFromAPI:(uuid:string)=>void;
  requestUserNotCLientListFromAPI:(uuid:string)=>void;
  requestClientToogle:(uuid:string,useruuid:string, action:string) => void;
  // StartUpload:(uuid:string)=>void;
  onConfigChange: (data:any, type:string) => void;
}


const { Meta }= Card;
//export const UserDetailsView = (props:LocalProps) => {
  const MyUserDetailsView = class UserDetailsView extends Component<LocalProps & {intl:any}, {}> 
  {
     
  
  componentDidMount(){
    setTimeout(() => {
      //setInterval(() => {
       this.props.onLoadRequested(this.props.loadeduuid);
       this.props.requestUserCLientListFromAPI(this.props.loadeduuid);
       this.props.requestUserNotCLientListFromAPI(this.props.loadeduuid);
    }, 20);
  }
       

  onTabChange(key: string, type: string) {
    console.log(key, type);
    // this.props.setState({ [type]: key });
    //throw new Error('Function not implemented.');
  }

  onChangeUsername=(value:any) => {
    console.log(value.target.value);
    this.props.onConfigChange(value.target.value, "username");
    }
  onChangeName=(value:any) => {
    console.log(value.target.value);
    this.props.onConfigChange(value.target.value, "name");
    }
  onChangeEmail=(value:any) => {
    console.log(value.target.value);
    this.props.onConfigChange(value.target.value, "email");
    }
  onChangeGender=(value:any) => {
    console.log(value.target.value);
    this.props.onConfigChange(value.target.value, "gender");
    }
  onChangeRole=(value:any) => {
    console.log(value.target.value);
    this.props.onConfigChange(value.target.value, "role");
    }
  onChangePassword=(value:any) => {
    console.log(value.target.value);
    this.props.onConfigChange(value.target.value, "password");
    }
  onChangePasswordVerify=(value:any) => {
    console.log(value.target.value);
    this.props.onConfigChange(value.target.value, "passwordverify");
    }

      onSubmit=() => {
        console.log("Submit the shit");
        this.props.onSubmit(this.props.userdetails, this.props.loadeduuid);
      }
  
  //     props.onLoadRequested(props.loadeduuid)
  

    callback = (key:any) => {
      console.log(key);
    }

    switchClient = (uuid: any) => {
      console.log('Success:', uuid);
      this.props.requestClientToogle(uuid, this.props.loadeduuid, "activate");
      setTimeout(() => {
        //setInterval(() => {
         this.props.onLoadRequested(this.props.loadeduuid);
        }, 300);
        setTimeout(() => {
         this.props.requestUserCLientListFromAPI(this.props.loadeduuid);
         this.props.requestUserNotCLientListFromAPI(this.props.loadeduuid);
      }, 500);

    };

    removeClient = (uuid: any) => {
      console.log('Success:', uuid);
      this.props.requestClientToogle(uuid, this.props.loadeduuid, "remove");
      setTimeout(() => {
        //setInterval(() => {
         this.props.requestUserCLientListFromAPI(this.props.loadeduuid);
         this.props.requestUserNotCLientListFromAPI(this.props.loadeduuid);
      }, 200);

    };

    addClient = (uuid: any) => {
      console.log('Success:', uuid);
      this.props.requestClientToogle(uuid, this.props.loadeduuid, "add");
      setTimeout(() => {
        //setInterval(() => {
         this.props.requestUserCLientListFromAPI(this.props.loadeduuid);
         this.props.requestUserNotCLientListFromAPI(this.props.loadeduuid);
      }, 200);

    };
 
    onFinish = (values: any) => {
      console.log('Success:', values);
      this.props.onSubmit(values, this.props.loadeduuid);
    };
  
    onFinishFailed = (errorInfo: any) => {
      console.log('Failed:', errorInfo);
    };

    mandantencolumns2 = [
      {
        title: <FormattedMessage id="Client" defaultMessage="Client" /> ,
        dataIndex: 'name',
        key: 'uuid',
        ellipsis: true,
      },
      {
        title: <FormattedMessage id="Customer" defaultMessage="Customer" />,
        dataIndex: 'customer',
        key: 'uuid',
        ellipsis: true,
        // render: (type:any, b:any) => (
        //   console.log(b),
        //     {b}
        //   ),
      },
      {
        title: <FormattedMessage id="Contact" defaultMessage="Contact" />,
        dataIndex: 'contact',
        key: 'uuid',
 
        // render: (type:any, b:any) => (
        //   console.log(b)
        //   ),
      },
      {
        title: <FormattedMessage id="Action" defaultMessage="Action" />,
        dataIndex: 'uuid',
        key: 'uuid',
        ellipsis: true,
        render: (uuid:string) => (
          <Button onClick={() => {this.addClient(uuid) as any}}>Add Client</Button>
        ),
      },
    ];

    useractivemandant = this.props.userdetails.activeMandant; // fix for active mandant in table

    mandantencolumns = [
      {
        title: <FormattedMessage id="Client" defaultMessage="Client" />,
        dataIndex: 'name',
        key: 'uuid',
        ellipsis: true,
         render: (type:any, row:any) => {
          
          console.log(this.props.userdetails.activeMandant, row.uuid)
          if (this.props.userdetails.activeMandant === row.uuid)
          {
            return(
            <span style={{"color":"red"}} >[ACTIVE] {row.name}</span>
            )
          }
          else
          {
            return(<div>
              <Button onClick={() => {this.switchClient(row.uuid) as any}}>Activate </Button>
              {row.name}
              </div>
              )
          }
  
          },
      },
      {
        title: <FormattedMessage id="Customer" defaultMessage="Customer" />,
        dataIndex: 'customer',
        key: 'uuid',
        ellipsis: true,
        // render: (type:any, b:any) => (
        //   console.log(b),
        //     {b}
        //   ),
      },
      {
        title: <FormattedMessage id="Contact" defaultMessage="Contact" />,
        dataIndex: 'contact',
        key: 'uuid',
        ellipsis: true,
        // render: (type:any, b:any) => (
        //   console.log(b)
        //   ),
      },
      {
        title: <FormattedMessage id="Action" defaultMessage="Action" />,
        dataIndex: 'uuid',
        key: 'uuid',
        ellipsis: true,
         render: (uuid:string) => (
           <Button onClick={() => {this.removeClient(uuid) as any}}>Remove Client</Button>
         ),
      },
    ];

    // atob, not Buffer: Vite provides no Node globals in the browser (anima_frontend#3).
    decode = (str: string):string => atob(str);

    showqrcode() 
    {
      const encodeddstring =  "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"
      
      const strings = this.decode(encodeddstring);
      const src="data:image/png;base64,"+strings
      return (
        <div>
        <img alt="tiles" src={src} width="200px" height="200px"/>
        </div>
        )
    };

    render(){
    return (
      <div>
        <Row gutter={16}>
          <Col span={4}>
            <Card
          hoverable
          cover={<img alt={(this.props.intl.formatMessage({id:"Avatar", defaultMessage:"Avatar"}))} src="/images/avatar.png" />}
        >
          {/* <Upload>
            <Button>
              <FontAwesomeIcon icon={["fas", "file-import"]}/> Upload Avatar
          </Button>
        </Upload> */}
          <Meta title={this.props.userdetails.username} description="" />
        </Card>
        </Col>
        <Col span={20}>
        <Card
          hoverable
        >
        <Tabs defaultActiveKey="1" onChange={this.callback}
              items={[
                { key: "1", label: "User Details", children: (<>
            <Card title={"Edit User "} style={cardmargin} hoverable styles={{ header: grayheader }}>
            
        {/* register your input into the hook by invoking the "register" function */}
        <Row gutter={16}>
        <Col span={8}>
          <label >Name:</label>
            </Col>
          <Col span={8}>    
          <input value={this.props.userdetails.name} onChange={this.onChangeName}/>
          </Col>
          <Col span={8}></Col>
          </Row> 
        <Row gutter={16}>
        <Col span={8}>
          <label >Username:</label>
            </Col>
        <Col span={8}>
        <input value={this.props.userdetails.username} onChange={this.onChangeUsername}/>       
        </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
          <label >E-Mail:</label>
            </Col>
          <Col span={8}>    
          <input  value={this.props.userdetails.email} onChange={this.onChangeEmail}  />
         
          </Col>
          </Row> 
        <Row gutter={16}>
        <Col span={8}>
          <label >Role:</label>
            </Col>
        <Col span={8}>
        {/* include validation with required or other standard HTML validation rules */}
        <select name="role" value={this.props.userdetails.role} style={{ width: 120 }} onChange={this.onChangeRole}>
          <option value="User">User</option>
          <option value="Admin">Admin</option>
        </select>
        
        {/* errors will return when field validation fails  */}
        </Col>
        </Row>
        <Row gutter={16}>
        <Col span={8}>
          <label >Gender:</label>
            </Col>
        <Col span={8}>
        {/* include validation with required or other standard HTML validation rules */}
  
        <select name="gender" value={this.props.userdetails.gender} style={{ width: 120 }} onChange={this.onChangeGender}>
          <option value="f">Female</option>
          <option value="m">Male</option>
          <option value="d">Div</option>
        </select>
        
        {/* errors will return when field validation fails  */}
       
        </Col>
        </Row>
        <Row gutter={16}>
        <Col span={8}>
          <label >Password:</label>
            </Col>
        <Col span={8}>
       
        {/* include validation with required or other standard HTML validation rules */}
        <input name="password" type="password" placeholder={"new password"}  onChange={this.onChangePassword}/>
       
        {/* errors will return when field validation fails  */}
        </Col>
        </Row>
        <Row gutter={16}>
        <Col span={8}>
          <label >Verify Password:</label>
            </Col>
        <Col span={8}>
    
        {/* include validation with required or other standard HTML validation rules */}
        <input name="passwordverify" type="password" placeholder={"new password"}  onChange={this.onChangePasswordVerify}/>
        {/* errors will return when field validation fails  */}

        </Col>
        </Row>
        <Row gutter={16}>
        <Col span={16}></Col>
        <Col span={8}>
        <Button type="primary" htmlType="submit" onClick={this.onSubmit}>
          Submit
        </Button>
        </Col>
        </Row>
       
      </Card>
          </>) },
                { key: "3", label: "Client Association", children: (<>
    
        <Table columns={this.mandantencolumns} dataSource={this.props.usermandanten} /> 
        <Table columns={this.mandantencolumns2} dataSource={this.props.listmandanten} /> 
    
          </>) },
                { key: "4", label: "Danger Zone", children: (<>
            <Row>
            {this.showqrcode()}
            {/* if (row.active == false){
          return(
          <span style={{"color":"red"}} >[INACTIVE] {row.username} </span>
        );
        }
        else
        {
          return(
            <span style={{"color":"black"}} >{row.username}</span>
          );
        } */}
      
          <Button danger onClick={() => {this.props.deactivateUser(this.props.loadeduuid)}} icon={<FontAwesomeIcon icon={["fas", "pause-circle"]}/>}>
            Deactivate 
          </Button>
          </Row>
          <Row>
          {/* <Button danger onClick={() => {props.deleteUser(props.loadeduuid)}} icon={<FontAwesomeIcon icon={["fas", "trash-alt"]}/>}>
            Delete //TODO Fill with Func
          </Button> */}
          </Row>
          </>) }
              ]} />
        </Card>
        </Col>
        </Row>
        
        </div>
    
      )
  }
};

export default injectIntl(MyUserDetailsView);

